import LinkEnhance from '@/component/LinkEnhance'
import Picture from '@/component/Picture'
import React from 'react'

import type { Game } from '@kulee/tga-sdk/types/types/game'

const SearchGameItem: React.FC<PropType> = ({ game, active = false }) => {
  const { code, battlePlayersNum } = game

  const href = battlePlayersNum ? `/battle/${code}/` : `/play/${code}/`

  return (
    <LinkEnhance
      className={`flex h-16 items-center gap-sm px-md hover:bg-primary-light/50 ${active && 'bg-primary-light/50'}`}
      href={href}
    >
      <div className="flex-shrink-0 flex-grow-0 basis-14 overflow-hidden rounded-xl">
        <Picture src={game.icon} />
      </div>
      <div className="overflow-hidden text-ellipsis text-nowrap font-custom-bold text-primary-text">
        {game.name}
        {battlePlayersNum && ' (PVP)'}
      </div>
    </LinkEnhance>
  )
}

interface PropType {
  game: Game
  active?: boolean
}

export default SearchGameItem
